<template>
  <div>
    <v-dialog
      v-model="cancelWithdrawDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      width="500"
    >
      <v-card width="500" class="mx-auto">
        <v-toolbar>
          <v-toolbar-title class="title">
            <span>
              {{ $t("cancelWithdraw") }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelWithdrawDialog = false">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="py-4 pt-8 pb-8">
          <div light class="px-4 d-flex justify-space-between">
            {{ $t("cancelWithdrawExplanation") }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelWithdrawDialog = false">
            {{ $t("BtnCancel") }}
          </v-btn>
          <v-btn
            color="info"
            text
            @click="confirmCancelWithdraw"
            :disabled="cancelingWithdraw"
          >
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-progress-linear :active="open" indeterminate></v-progress-linear>
    <div
      :class="{
        'ma-4': $vuetify.breakpoint.smAndUp,
        'mt-2': $vuetify.breakpoint.smAndDown,
      }"
    >
      <!-- Alert Bank Verification Status when is NOT verified -->
      <div>
        <v-alert v-if="alert.show" type="info" prominent dense elevation="1">
          <v-row
            align="center"
            :class="$vuetify.breakpoint.width < 426 ? 'd-flex flex-column' : ''"
          >
            <v-col class="grow d-flex align-center">
              {{ alert.message }}
            </v-col>
            <v-col
              class="shrink"
              :class="$vuetify.breakpoint.width < 426 ? 'pt-0' : ''"
            >
              <v-btn
                color="primary"
                @click="goToVerify"
                :style="$vuetify.breakpoint.width < 426 ? 'width: 100%;' : ''"
              >
                {{ $t("verification.pageName") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </div>
      <!-- Alert END -->
      <v-card>
        <div>
          <v-tabs
            class="pb-2"
            v-model="active"
            fixed-tabs
            color="primary"
            slider-color="primary"
          >
            <v-tab @click="listExtract()">
              {{ $t("tabExtract") }}
            </v-tab>
            <v-tab @click="listDeposits()">
              {{ $t("tabDeposit") }}
            </v-tab>
            <v-tab @click="listWithdraws()">
              {{ $t("tabWithdraw") }}
            </v-tab>

            <v-tab-item> </v-tab-item>
          </v-tabs>
        </div>

        <v-container grid-list-md>
          <Range />
          <div
            class="d-flex range-wrap"
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
          >
            <v-layout row wrap justify-start>
              <v-flex md12 xs12 lg12>
                <div class="flex-grow-1 px-2 pb-3">
                  <v-select
                    v-show="!showResume"
                    v-model="select_status"
                    :label="$t('selectLabelTranslated')"
                    :items="selectItems"
                    item-text="text"
                    item-value="value"
                    prepend-icon="mdi-wallet"
                    solo-inverted
                    hide-details
                  ></v-select>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-container>
      </v-card>

      <!-- Datatable -->
      <v-card class="mt-4 elevation-0">
        <!-- Coluna Botões Mobile -->

        <v-col cols="12" class="align-self-center">
          <v-btn
            v-if="$isCreditOnline()"
            @click="showDialogDeposit()"
            class="mr-2 px-4 py-2"
            color="green"
          >
            <v-icon class="mr-2" small>mdi-cash</v-icon>
            {{ $t("BtnDeposit") }}
          </v-btn>
          <v-btn
            v-if="$isCreditOnline()"
            @click="showDialogwithdrawal()"
            class=" mr-2"
            color="black"
            :disabled="isCompletlyVerified === false || retrieveUserCash == 0"
          >
            <v-icon class="mr-2 mb-1" small>mdi-cash-refund</v-icon>
            {{ $t("BtnWithdraw") }}
          </v-btn>
        </v-col>
      </v-card>

      <!--  Dialog Saque -->
      <DialogWithdrawal />

      <!--  Tabela de Saques de depósitos -->
      <v-data-table
        v-show="!showResume"
        :headers="headers"
        :items="datatableItems"
        :items-per-page="10"
        class="elevation-2 "
        :header-props="headerProps"
      >
        <!-- Deposits -->
        <template v-slot:item.deposit_date="{ item }">
          <span :class="lineThrough(item.statusUI)">
            {{ item.deposit_date }}
          </span>
        </template>
        <template v-slot:item.deposit_id="{ item }">
          <span :class="lineThrough(item.statusUI)">
            {{ item.deposit_id }}
          </span>
        </template>
        <template v-slot:item.value_consolidated="{ item }">
          <span
            :class="lineThroughAndColor(item.value_consolidated, item.statusUI)"
          >
            {{ item.value_consolidated }}
          </span>
        </template>

        <template v-slot:item.qrcode="{ item }">
          <v-btn-toggle dense>
            <v-btn
              small
              title="Vizualizar"
              @click="showQrCode(item)"
              :disabled="!item.qrcode"
              :class="lineThrough(item.statusUI)"
            >
              <v-icon size="24">
                mdi-magnify-plus-outline
              </v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
        <template v-slot:item.status="{ item }">
          <div v-html="item.status"></div>
        </template>
        <!-- Deposits -->

        <!-- Withdraws  -->

        <template v-slot:item.withdraw_id="{ item }">
          <span :class="lineThrough(item.statusUI)">
            {{ item.withdraw_id }}
          </span>
        </template>
        <template v-slot:item.value_requested="{ item }">
          <span
            :class="lineThroughAndColor(item.value_requested, item.statusUI)"
          >
            {{ item.value_requested }}
          </span>
        </template>
        <template v-slot:item.type_key="{ item }">
          <v-span v-if="item.nome_metodo == 'Carteira'">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-span>
          <span :class="lineThrough(item.statusUI)" v-else>
            {{ item.type_key }}
          </span>
        </template>
        <template v-slot:item.key_pix="{ item }">
          <span :class="lineThrough(item.statusUI)">
            {{ item.key_pix }}
          </span>
        </template>
        <template v-slot:item.register_date="{ item }">
          <span :class="lineThrough(item.statusUI)">
            {{ item.register_date }}
          </span>
        </template>
      </v-data-table>

      <!-- Table a da view Extrato -->
      <v-data-table
        v-show="showResume"
        :headers="extractHeaders"
        :items="extract"
        :items-per-page="10"
        class="elevation-2"
        :header-props="headerProps"
      >
        <template v-slot:item.value="{ item }">
          <span
            :class="
              lineThroughAndColor(
                item.value,
                item.status_operation,
                item.id_operation
              )
            "
          >
            {{ item.value }}
          </span>
        </template>
        <template v-slot:item.date_entry="{ item }">
          <span :class="lineThrough(item.status_operation)">
            {{ item.date_entry }}
          </span>
        </template>
        <template v-slot:item.name_operation="{ item }">
          <span :class="lineThrough(item.status_operation)">
            {{ item.name_operation }}
          </span>
        </template>

        <template v-slot:item.status_operationUI="{ item }">
          <div v-html="item.status_operationUI"></div>
        </template>
        <template v-slot:item.current_balance="{ item }">
          <div v-if="item.current_balance != null">
            {{ item.current_balance }}
          </div>
          <v-icon v-else> mdi-dots-horizontal </v-icon>
        </template>
        <template v-slot:item.previous_balance="{ item }">
          <div v-if="item.previous_balance != null">
            {{ item.previous_balance }}
          </div>
          <v-icon v-else> mdi-dots-horizontal </v-icon>
        </template>
      </v-data-table>

      <v-container v-show="showResume"> </v-container>
      <!-- Dialog Qr Code -->
      <DialogQrcode />
    </div>
  </div>
</template>

<script>
import Range from "../../_components/filter/RangeDate/RangeDate.vue";
import DialogWithdrawal from "@/components/dialog-withdrawal/dialog-withdrawal";
import DialogQrcode from "@/components/dialog-deposit/dialog-qrcode";
export default {
  name: "views-dashboard-user-deposit-listDeposits",
  components: {
    Range,
    DialogWithdrawal,
    DialogQrcode,
  },
  data: () => ({
    listTimeoutId: 0,

    headerProps: {
      sortByText: "Filtrar por",
    },

    // TABS
    active: null,
    // default endpoit
    endpoint: "",

    // Datatable
    datatableItems: [],
    headers: [],

    showResume: false,

    // Extract Table
    extract: [],

    select_status: "",

    open: true,

    checkBank: "",
    bankVerificationStatus: "",
    verificationAlert: false,
    verified: false,
    learnMoreDialog: false,
    verifyBtnLoading: false,
    verifyBtnDisable: false,
    checkVerificationIntervalID: null,
    closeAlert: true,

    // processing animation
    loader: null,
    processingLoading: true,

    cancelWithdrawDialog: false,
    cancelingWithdraw: false,

    alert: {
      show: false,
      message: "",
    },

    isCompletlyVerified: false,
  }),
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    qrcode() {
      return this.$store.state.qrcode;
    },
    refreshBankTable() {
      return this.$store.state.tableBank;
    },
    extractHeaders() {
      let headers = [
        {
          text: this.$t("extractOnlineHeaderDate"),
          value: "date_entry",
        },
        {
          text: this.$t("extractOnlineHeaderOperation"),
          value: "name_operation",
        },
      ];

      if (this.$store.state.operators.casino != "0") {
        headers.push({ text: this.$t("game"), value: "name_game" });
      }

      headers = [
        ...headers,
        {
          text: this.$t("extractOnlineHeaderValue"),
          value: "value",
        },
        {
          text: this.$t("previous_balance"),
          value: "previous_balance",
          align: "center",
        },
        {
          text: this.$t("current_balance"),
          value: "current_balance",
          align: "center",
        },
      ];

      return headers;
    },
    selectItems() {
      return [
        {
          text: this.$t("selectAll"),
          value: "",
        },
        {
          text: this.$t("selectRequested"),
          value: "1",
        },
        {
          text: this.$t("selectConsolidated"),
          value: "3",
        },
        {
          text: this.$t("selectCanceled"),
          value: "4",
        },
      ];
    },
    // Recupera o saldo do User para
    // usar na experiência do Alert
    retrieveUserCash() {
      return this.$store.state.cash;
    },
    verifyBankEnabled() {
      return this.$store.state.operators.verify_bank == "1";
    },
  },
  mounted() {
    this.fetchVerificationStatus();
    this.listExtract();
    this.$store.commit("showDialogQrcode", {
      status: false,
      obj: {},
    });
  },
  destroyed() {
    clearInterval(this.checkVerificationIntervalID);
  },
  watch: {
    // Realiza o consumo da API quando o os filtros são modificados
    // rangeDate(val) {
    //   console.log(val);
    // },
    "rangeDate.date_start"() {
      this.debounceListData();
    },
    "rangeDate.date_final"() {
      this.debounceListData();
    },
    select_status() {
      if (this.select_status == "" && this.datatableItems == []) return;
      this.debounceListData();
    },
    // Para quando o usuário realizar um saque ou Deposito, fazer o refresh dos dados
    refreshBankTable(val) {
      if (!val) return;
      this.debounceListData();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
  },

  methods: {
    // Prepara o ambiente para a view de depositos
    listDeposits() {
      this.showSelectStatus = true;
      this.showResume = false;
      this.endpoint = "/player/online/listTransactions/listDeposits";
      (this.datatableItems = []),
        (this.headers = [
          {
            text: this.$t("depositOnlineHeaderId"),
            value: "deposit_id",
          },
          {
            text: this.$t("depositOnlineHeaderValue"),
            value: "value_consolidated",
          },
          {
            text: this.$t("depositOnlineHeaderStatus"),
            value: "status",
          },
          {
            text: this.$t("depositOnlineHeaderDepositDate"),
            value: "deposit_date",
          },
          {
            text: this.$t("depositOnlineHeaderDepositQrcode"),
            value: "qrcode",
          },
        ]);
      // Call Function
      this.debounceListData();
    },
    // Prepara o ambiente para a view de saques
    listWithdraws() {
      this.showResume = false;
      this.endpoint = "/player/online/listTransactions/listWithdraws";
      (this.datatableItems = []),
        (this.headers = [
          {
            text: this.$t("withdrawOnlineHeaderId"),
            value: "withdraw_id",
          },
          {
            text: this.$t("withdrawOnlineHeaderValue"),
            value: "value_requested",
          },
          {
            text: this.$t("withdrawOnlineHeaderStatus"),
            value: "status",
          },
          {
            text: this.$t("withdrawOnlineHeaderKeyType"),
            value: "type_key",
          },
          {
            text: this.$t("withdrawOnlineHeaderPixKey"),
            value: "key_pix",
          },
          {
            text: this.$t("withdrawOnlineHeaderDateRegister"),
            value: "register_date",
          },
        ]);
      // Call Function
      this.debounceListData();
    },

    // Prapara o Ambiente para a vire Extratos
    listExtract() {
      this.showResume = true;
      // endpoint to extract
      this.endpoint = "/player/online/bank/extractOnline";
      // Disable select status
      this.showSelectStatus = false;
      // Call Function
      this.debounceListData();
    },

    // Função principal realizando o consumo da API
    listData: function() {
      this.open = true;
      var body = {
        ...this.rangeDate,
        status: this.select_status,
      };

      this.$axios
        .post(this.endpoint, this.$formdata(body))
        .then((response) => {
          if (!response.data.dados) return;
          // Tratamento quando o endpoint é de deposito
          if (this.endpoint == "/player/online/listTransactions/listDeposits") {
            this.datatableItems = response.data.dados;
            this.depositsUI();
          }
          // Tratamento quando o endpoint é de saque
          if (
            this.endpoint == "/player/online/listTransactions/listWithdraws"
          ) {
            this.datatableItems = response.data.dados;
            this.withdrawsUI();
          }
          // Tratamentos quando o item é extrato (Default)
          if (this.endpoint == "/player/online/bank/extractOnline") {
            this.extract = response.data.dados;

            this.extract.forEach((entry) => {
              if (entry.name_game == null) {
                entry.name_game = "SportsBook";
              }

              if (entry.id_operation == "113") {
                entry.name_operation = "Freespins";
              }
            });

            // this.extract.sort(function(a, b) {
            //   if (a.date_entry < b.date_entry) {
            //     return 1;
            //   }
            //   if (a.date_entry > b.date_entry) {
            //     return -1;
            //   }
            //   // a must be equal to b
            //   return 0;

            this.extractUI();
          }
        })
        .catch((error) => {
          const msg = error.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(
          () =>
            setTimeout(() => {
              this.open = false;
            }, 400),
          this.$store.commit("refreshTableBank", false)
        );
    },

    // Só para operadores Credit Online 2
    showDialogwithdrawal() {
      this.$store.commit("dialogWithDrawal", true);
    },

    // Liga o dialog de saldo insuficiente na carteira Pay4Fun
    showInsufficientFundsDialog() {
      this.$store.commit("setMotiveDialog", true);
    },

    // Chama Dialog do btn deposito
    showDialogDeposit() {
      this.$store.commit("dialogDeposit", true);
    },
    // Final de operadores Credit Online 2

    // Tratamento de UI Saque
    depositsUI() {
      // tratamento de Data de Depósito e status
      this.datatableItems.forEach((item) => {
        item.deposit_date = new Date(
          item.deposit_date.replace(" ", "T")
        ).toLocaleString();

        item.statusUI = item.status;

        item.status = this.statusOperationUI(item.status, "deposit");
      });
    },
    // Tratamento de UI Saque
    withdrawsUI() {
      // tratamento de Data de Registro do Saque
      this.datatableItems.forEach((item) => {
        if (item.nome_metodo === "Carteira") {
          item.key_pix = this.$t("wallet");
        }

        item.register_date = new Date(
          item.register_date.replace(" ", "T")
        ).toLocaleString();
        item.withdraw_date = item.withdraw_date
          ? new Date(item.withdraw_date.replace(" ", "T")).toLocaleString()
          : "Não realizado";
        item.type_key = this.typePix(item.type_key);
        item.statusUI = item.status;
        item.value_requested = (Number(item.value_requested) * -1).toFixed(2);

        item.status = this.statusOperationUI(item.status);
      });
    },

    // Tratamento de UI para Extrato
    extractUI() {
      this.extract.forEach((item) => {
        item.date_entry = new Date(
          item.date_entry.replace(" ", "T")
        ).toLocaleString();

        item.date_authorization =
          item.date_authorization == null
            ? "Aguardando"
            : new Date(
                item.date_authorization.replace(" ", "T")
              ).toLocaleString();

        item.date_finalized =
          item.date_finalized == null
            ? "Em análise"
            : new Date(item.date_finalized.replace(" ", "T")).toLocaleString();

        item.status_operationUI = this.statusOperationUI(item.status_operation);

        // Legenda id_operation
        // 1 - Aposta Online, - value_consolidated (-)
        // 2 - Extorno Aposta, - value_consolidated (+)
        // 3 - Compra de Crédito Online, - value_consolidated (+)
        // 4 - Pagamento de Aposta, - value_consolidated (+)
        // 5 - Bônus de depósito, value_considated (+)
        // 6 - Saque de Crédito Online - value_requested (-)
        // 7 - Aposta Online com Bônus - value_requested (-)
        // 8 - Saque de crédito instantâneo, value_requested (-)
        // 9 - Compra de Crédo Online por Adminstrador, value_considated (+)
        // 10 - Promoção de Bônus, value_considated (+)
        // 11 - Encerrar Apostas, value_consolidated (+)
        // 12 - Saldo de Migração, value_consolidated (+)
        // 14 - Cancelamento Prêmio SportsBook, value_consolidated (-)
        // 15 - Reativação Prêmio Sportsbook (+)
        // 101 - Aposta Cassino, value_consolidated (-)
        // 108 - Rollback de aposta de cassino (+)
        // 109 - Rollback de aposta de cassino
        // 114 - Aposta isenta cassino (-)
        // 115 - Prêmio isento cassino (-)
        // 117 - Rollback de prêmio de jogador isento (-)
        // 116 - Rollback de aposta de jogador isento (+)

        // 1 - Aposta Online,
        // 8 - Saque de crédito instantâneo
        if (
          item.id_operation == 1 ||
          item.id_operation == 7 ||
          item.id_operation == 8 ||
          item.id_operation == 13 ||
          item.id_operation == 14 ||
          item.id_operation == 101 ||
          item.id_operation == 109 ||
          item.id_operation == 114 ||
          item.id_operation == 117
        ) {
          item.value = (Number(item.value_consolidated) * -1).toFixed(2);
        }
        // 6 - Saque de Crédito Online
        if (item.id_operation == 6) {
          item.value = (Number(item.value_requested) * -1).toFixed(2);
        }
        // 2 - Extorno Aposta,
        // 3 - Compra de Crédito Online,
        // 4 - Pagamento de Aposta,
        // 5 - Bônus de depósito,
        // 9 - Compra de Crédo Online por Adminstrador,
        // 102 - Prêmio Cassino, value_consolidated (+)
        // 103 - Reembolso Cassino, value_consolidated (+)
        // 104 - Premio Jackpot (+)
        // 105 - Premio Campanha Casino (+)
        // 106 - Premio Drops&Wins (+)
        // 16 - Depósito Manual Feito Por Administrator (+)
        // 18 - Pagamento de comissão do afiliado (+)
        // 108 - Rollback de prêmio de cassino
        // 113 - Freespins

        if (
          item.id_operation == 2 ||
          item.id_operation == 3 ||
          item.id_operation == 4 ||
          item.id_operation == 5 ||
          item.id_operation == 9 ||
          item.id_operation == 10 ||
          item.id_operation == 11 ||
          item.id_operation == 12 ||
          item.id_operation == 15 ||
          item.id_operation == 102 ||
          item.id_operation == 103 ||
          item.id_operation == 104 ||
          item.id_operation == 105 ||
          item.id_operation == 106 ||
          item.id_operation == 16 ||
          item.id_operation == 18 ||
          item.id_operation == 108 ||
          item.id_operation == 113 ||
          item.id_operation == 115 ||
          item.id_operation == 116
        ) {
          item.value = Number(item.value_consolidated).toFixed(2);
        }

        if (item.id_operation == 107) {
          item.value = Number(item.value_consolidated).toFixed(2);
        }
      });
    },
    // Status for extratc / deposit / withdraw
    statusOperationUI(value, operation) {
      const obj = {
        1: `<span class="my-1 v-chip theme--light v-size--small orange darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "requested"
        )}</span></span>`,
        2: `<span class="my-1 v-chip theme--light v-size--small grey darken  white--text"><span class="v-chip__content">${this.$t(
          "authorized"
        )}</span></span>`,
        3: `<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">${this.$t(
          "consolidated"
        )}</span></span>`,
        4:
          // Essa condicional faz com que deposito status 4 apareça como 'Expirado'
          // E nas demais operações apareça como 'Cancelado'. Extrato, depósito e saque compartilham essa função
          operation == "deposit"
            ? `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content">${this.$t(
                "expired"
              )}</span></span>`
            : `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content">${this.$t(
                "canceled"
              )}</span></span>`,
      };
      return obj[value];
    },

    // Passando item para o Qr Code e chamando a dialog importada
    showQrCode(item) {
      this.$store.commit("showDialogQrcode", {
        status: true,
        obj: item,
      });
    },

    lineThrough(status) {
      if (status == 4) {
        return "line-through";
      }
    },
    lineThroughAndColor(value, status, id_operation = 0) {
      if (id_operation == 107) {
        return "white--text";
      }

      if (status == 4) {
        if (value == 0) {
          return "line-through white--text ";
        }
        if (value > 0) {
          return "line-through green--text ";
        }
        if (value < 0) {
          return "line-through red--text ";
        }
      }
      if (value == 0) return "white--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    // Status do deposito
    statusValue(value) {
      const obj = {
        "0": "Cancelado",
        "1": "Depósito solicitado",
        "2": "Pago",
      };
      return obj[value];
    },

    // Legenda para chave Pix
    typePix: function(value) {
      if (value == "EMAIL") {
        return "E-mail";
      }
      if (value == "PHONE") {
        return "Telefone";
      }
      if (value == "EVP") {
        return "Chave aleatória";
      } else {
        return "CPF";
      }
    },
    // Altara as cores do valores de acordo com o valor
    getColor(value) {
      if (value == 0) return "white--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    // Status de Verificação de Banco
    fetchVerificationStatus() {
      this.$axios.get("/player/profile/verificationStatus").then((res) => {
        const bankVerification = res.data.dados.bank_verification;
        const documentVerification = res.data.dados.document_verification;

        let showAlert = false;

        if (bankVerification.active == "1") {
          if (bankVerification.playerStatus != "1") {
            showAlert = true;
          }
        }

        if (documentVerification.active == "1") {
          if (documentVerification.playerStatus != "3") {
            showAlert = true;
          }
        }

        if (showAlert === false) {
          this.isCompletlyVerified = true;
        }

        this.alert.show = showAlert;
        this.alert.message = this.$t("verificationAlertMessage");
      });
    },

    cancelWithdraw(item) {
      this.currentWithdraw = item;
      this.cancelWithdrawDialog = true;
    },
    confirmCancelWithdraw() {
      if (this.cancelingWithdraw) {
        return;
      }

      this.cancelingWithdraw = true;

      const body = { withdraw_id: this.currentWithdraw.withdraw_id };

      this.$axios
        .post("/player/online/bank/cancelWithdraw", this.$formdata(body))
        .then((res) => {
          const cash = Number(this.$store.state.cash);
          const cashRes = Number(res.data.dados.balance);

          if (cashRes > cash) {
            this.$store.commit("setCash", cashRes);
          }

          this.$store.commit("setNotification", {
            color: "success",
            msg: res.data.messages,
          });

          this.debounceListData();
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            color: "warning",
            msg: err.response.data.messages.error,
          });
        })
        .finally(() => {
          this.cancelingWithdraw = false;
          this.cancelWithdrawDialog = false;
        });
    },
    goToVerify() {
      this.$router.push({
        name: "Verify",
      });
    },
    debounceListData() {
      clearTimeout(this.listTimeoutId);

      this.listTimeoutId = setTimeout(() => {
        this.listData();
      }, 100);
    },
  },
};
</script>
<style>
.line-through {
  text-decoration: line-through;
}

/* Processing animation  */

.custom-loader {
  background: "mdi-timer-sand", "mdi-timer-sand-paused",
    "mdi-timer-sand-complete";
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
